import { useState, useRef } from 'react'
import { Chip }      from '../../components'
import { useReveal } from '../../hooks/useReveal'
/**
 * FlipCard — glass card with a CSS 3D flip on click.
 * Front: icon, name, brief, tech chips.
 * Back:  full detail paragraph + tech stack.
 * Also applies a real-time mouse-tilt effect using perspective transforms.
 */
export function FlipCard({ p, delay = 0 }) {
  const [flipped, setFlip] = useState(false)
  const [ref, vis] = useReveal()
  const wrapRef = useRef()
  const toggle = () => setFlip(f => !f)

  const onMove = e => {
    const el = wrapRef.current; if (!el) return
    const r  = el.getBoundingClientRect()
    const px = (e.clientX - r.left) / r.width  - 0.5
    const py = (e.clientY - r.top)  / r.height - 0.5
    el.style.transform = `perspective(1000px) rotateY(${px * 10}deg) rotateX(${-py * 10}deg)`
  }
  const onLeave = () => { if (wrapRef.current) wrapRef.current.style.transform = 'perspective(1000px) rotateY(0) rotateX(0)' }

  return (
    <div ref={el => { ref.current = el; wrapRef.current = el }} role="button" tabIndex={0}
      className={`fwrap rv${vis ? ' in' : ''}${flipped ? ' flipped' : ''}`}
      style={{ transitionDelay: `${delay}s`, transition: 'transform .15s ease-out, opacity .6s ease, translate .6s ease' }}
      onMouseMove={onMove} onMouseLeave={onLeave}
      onClick={toggle}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle() } }}>
      <div className="finner">
        <div className="fface">
          <div className="pi">{p.icon}</div>
          <div className="pn">{p.name}</div>
          <p className="pd">{p.brief}</p>
          <div className="chips">{p.tags.map(t => <Chip key={t} label={t}/>)}</div>
          <div className="flip-hint">Click to flip ↻</div>
        </div>
        <div className="fface fback">
          <h4 style={{ fontFamily: 'var(--disp)', fontSize: '.95rem', fontWeight: 700, color: 'var(--cy)', marginBottom: '.6rem' }}>{p.name}</h4>
          <p style={{ fontSize: '.77rem', color: 'var(--mu)', lineHeight: 1.65, flex: 1 }}>{p.detail}</p>
          <div className="chips" style={{ marginTop: '.9rem' }}>{p.back.map(t => <Chip key={t} label={t}/>)}</div>
          <div className="flip-hint">Click to flip back ↺</div>
        </div>
      </div>
    </div>
  )
}
